var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, useEffect, forwardRef } from 'react';
import cx from 'classnames';
import styles from './Button.module.css';
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Size100"] = "100";
    ButtonSize["Size200"] = "200";
    ButtonSize["Size300"] = "300";
})(ButtonSize || (ButtonSize = {}));
export var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition || (IconPosition = {}));
export const Button = forwardRef((_a, ref) => {
    var { children, className, href, label, iconOnly, isInline, iconOnlyOnMobileDevice, target, icon, iconPosition = IconPosition.Left, size = ButtonSize.Size100, fontSize = size, iconSize = size } = _a, rest = __rest(_a, ["children", "className", "href", "label", "iconOnly", "isInline", "iconOnlyOnMobileDevice", "target", "icon", "iconPosition", "size", "fontSize", "iconSize"]);
    const isLink = !!href;
    const ButtonElement = isLink ? 'a' : 'button';
    useEffect(() => {
        import('focus-visible').catch(() => null);
    }, []);
    const iconClone = icon &&
        cloneElement(icon, {
            className: cx(icon.props.className, {
                [styles[`icon-size-${iconSize}-only-mobile`]]: iconOnlyOnMobileDevice,
                [styles[`${isInline ? 'inline-' : ''}icon-size-${iconSize}`]]: !iconOnly && !iconOnlyOnMobileDevice
            })
        });
    return (React.createElement(ButtonElement, Object.assign({ ref: ref, className: cx({
            [styles.linkComponent]: isLink,
            [styles[`${isInline ? 'inline-' : ''}size-${size}`]]: true,
            [styles[`${isInline ? 'inline-' : ''}font-size-${fontSize}`]]: true,
            [styles[`icon-only-padding-${iconSize}`]]: iconOnly,
            [styles[`icon-only-padding-mobile-${iconSize}`]]: iconOnlyOnMobileDevice
        }, styles.component, className) }, (isLink ? { href, target } : {}), rest),
        iconPosition === IconPosition.Left && iconClone,
        React.createElement("span", { className: cx({
                [styles.screenReaderOnly]: iconOnly,
                [styles.screenReaderOnlyMobileDevice]: iconOnlyOnMobileDevice,
                [styles[`icon-${iconPosition}-size-${iconSize}`]]: !!icon
            }) },
            label,
            children),
        iconPosition === IconPosition.Right && iconClone));
});
//# sourceMappingURL=Button.js.map